import TransactionsList from "../../components/Transactions/TransactionsList";

function TransactionListPage(){
    return (
        <TransactionsList  />
    );
}
export default TransactionListPage;